import { FC } from 'react';
// Components
import Accordion from 'components/Accordion';
import ThemeForm from './ThemeForm';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  defaultExpanded?: boolean;
}

const SectionTheme:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();

  return (
    <div react-scroll="theme">
      <Accordion label={t('labels.theme')} icon="theme" defaultExpanded={defaultExpanded}>
        <ThemeForm />
      </Accordion>
    </div>
  )
}

export default SectionTheme;
